import { http } from '@pendo/http';
import { v4 as uuid } from 'uuid';

export default function generateUniqueId () {
    // Some browsers will cache the response of multiple in-flight requests to the same endpoint.
    // This is a workaround to ensure that each request returns a unique ID.
    const id = uuid();

    return http.get(`/api/s/_SID_/object/makeid?nonce=${id}`);
}
